import { Form, FormInstance, Input } from "antd";

type Props = {
  form: FormInstance<any>;
};

export default function PaymentOrganization({ form }: Props) {
  return (
    <div>
      <Form.Item
        name="sPay Wallet Number"
        label="sPay Wallet Number"
        className="mb-1"
        rules={[
          {
            required: true,
            message: "Please enter sPay wallet number",
          },
        ]}
      >
        <Input size="large" placeholder="Wallet number" />
      </Form.Item>
    </div>
  );
}
